import { render, staticRenderFns } from "./myCharts4.vue?vue&type=template&id=5edcf550"
import script from "./myCharts4.vue?vue&type=script&lang=js"
export * from "./myCharts4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports